import { render, staticRenderFns } from "./SoftwareLicenseView.vue?vue&type=template&id=12b15100&scoped=true&"
import script from "./SoftwareLicenseView.vue?vue&type=script&lang=js&"
export * from "./SoftwareLicenseView.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLicenseView.vue?vue&type=style&index=0&id=12b15100&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b15100",
  null
  
)

export default component.exports